import { Guid } from '../../model/guid';
import { WidgetDataCache } from './widgetDataCache';
import { WidgetPrefetchedDataStore } from './widgetPrefetchedDataStore';
import { WidgetType } from '@ael/core-api';
import {ProjectViewModel} from "../../../../config/configs";

type RequestBody = string | Record<string, unknown>;
export type WidgetDataResponse = unknown;
interface IWidgetDataRepository {
  getWidgetData: (requestBody: RequestBody, widgetType: WidgetType) => Promise<WidgetDataResponse>;
}

interface IWidgetDataRepositoryWithCache {
  getWidgetData: (requestBody: RequestBody, widgetType: WidgetType, widgetId: Guid) => Promise<WidgetDataResponse>;
}

class WidgetDataRepositoryWithCache implements IWidgetDataRepositoryWithCache {
  cache: WidgetDataCache;
  prefetchedCache: WidgetPrefetchedDataStore;
  repository: IWidgetDataRepository;
  constructor() {
    this.prefetchedCache = new WidgetPrefetchedDataStore();
    this.cache = new WidgetDataCache();
  }

  private _serializeRequestBody = (requestBody: RequestBody) => JSON.stringify(requestBody);

  getWidgetData = async (requestBody: RequestBody, widgetType: WidgetType, widgetId: Guid) =>
    this.cache.tryGetDataForWidget(widgetType, this._serializeRequestBody(requestBody), () =>
      this.prefetchedCache.tryGetDataForWidget(widgetId, () => this.repository.getWidgetData(requestBody, widgetType))
    );

  populateCache = (initData: ProjectViewModel["initializationWidgetData"]) => {
    initData.map((entry) => this.prefetchedCache.populateStore(entry.widgetId, entry.response));
  };
}

const WidgetDataRepositoryWithCacheSingleton = new WidgetDataRepositoryWithCache();

export { WidgetDataRepositoryWithCacheSingleton as WidgetDataRepository };
